const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Sofort24 = function Sofort24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M30.456 22H3.548A1.563 1.563 0 0 1 2 20.436V3.564C2 2.7 2.7 2 3.564 2H30.44c.864 0 1.564.7 1.564 1.564V20.44A1.565 1.565 0 0 1 30.456 22z",
      fill: "#EF809F",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m20.688 4.756-.93 4.635.398.093a.737.737 0 0 1 .412.24c.26.276.384.736.328 1.408-.177 2.127-1.212 3.528-3.565 3.552a.218.218 0 0 1-.059.008c-1.737 0-3.211-1.269-3.255-3.08l-.393-.392c-.484-.484-.56-1.16-.172-1.56l.04-.044a.92.92 0 0 1 .608-.276c-.27-.533-.184-1.118.236-1.404l.06-.04c.461-.267.86-.162 1.2.178l-.392-3.222c-.132-.56.212-1.176.74-1.288a1.028 1.028 0 0 1 1.22.8l.665 2.843.843-2.887a1.07 1.07 0 0 1 1.304-.76c.516.152.824.676.712 1.196zm-.424-.088-.928 4.625-1.672-.389-.01-.003c-.02-.005-.055-.014-.102-.021a1.55 1.55 0 0 0-.576.004.908.908 0 0 0-.554.352l-.305-.455-.485-3.997-.004-.024c-.084-.336.124-.712.404-.772a.599.599 0 0 1 .452.084.601.601 0 0 1 .256.38l.848 3.621a.213.213 0 0 0 .156.199.216.216 0 0 0 .268-.148l1.076-3.688a.642.642 0 0 1 .772-.46.596.596 0 0 1 .404.692zm-4.513 4.345.479.714c-.065.342-.006.643.23.885a.506.506 0 0 1-.16.172l-.048.028a.54.54 0 0 1-.752-.144l-.944-1.404c-.256-.392-.224-.8.024-.972l.044-.032c.32-.184.588-.044.864.36l.226.337c.01.02.022.04.037.056zm1.04 1.329a.218.218 0 0 1 .106.085c.126.083.303.155.543.221l1.66.372c.276.064.188.476-.088.424l-.052-.008a1.513 1.513 0 0 0-.66.076c-.404.152-.656.5-.688 1.148a.218.218 0 0 1-.228.204.215.215 0 0 1-.204-.228c.032-.716.312-1.184.76-1.436l-.604-.14a2.648 2.648 0 0 1-.53-.2.965.965 0 0 1-.27.28l-.048.032a1.023 1.023 0 0 1-.084.051.974.974 0 0 1-.156 1.133l-.044.044a.977.977 0 0 1-1.376.02l-.324-.323c.258 1.269 1.37 2.127 2.684 2.162a.224.224 0 0 1 .036-.003c2.168.02 3.08-1.196 3.244-3.156.048-.56-.048-.9-.216-1.08a.406.406 0 0 0-.128-.092l-.048-.016-2.52-.588a.381.381 0 0 0-.04-.008l-.04-.008a1.056 1.056 0 0 0-.404 0 .48.48 0 0 0-.384.36c-.085.284-.078.5.102.674zm-2.356-.481a.49.49 0 0 0-.63.059l-.04.044c-.209.216-.165.624.167.956l1.2 1.188a.537.537 0 0 0 .76-.008l.04-.044a.537.537 0 0 0 .031-.717.975.975 0 0 1-.823-.427l-.705-1.051zm-2.231 8.89c0 .669-.52 1.125-1.2 1.125-.476 0-.884-.216-1.136-.56l.468-.468c.14.18.372.376.676.376.284 0 .48-.168.48-.44 0-.288-.232-.36-.596-.464-.668-.196-.94-.544-.94-.996 0-.568.432-1.056 1.112-1.056.428 0 .824.2 1 .588l-.564.356c-.108-.176-.256-.292-.456-.292-.236 0-.384.16-.384.364 0 .244.216.32.56.42.54.16.98.428.98 1.048zm.244-.151c0 .7.584 1.276 1.304 1.276.72 0 1.304-.576 1.304-1.276 0-.7-.584-1.276-1.304-1.276-.72 0-1.304.576-1.304 1.276zm1.928 0c0 .36-.276.636-.624.636a.62.62 0 0 1-.624-.636.62.62 0 0 1 .624-.636c.348 0 .624.276.624.636zm2.364-2.288v.64c-.38-.016-.656.176-.656.6v.26c.152-.16.368-.24.636-.24v.648c-.376.008-.636.248-.636.584v1.008h-.68v-2.3c0-.648.408-1.2 1.236-1.2h.1zm.18 2.288c0 .7.584 1.276 1.304 1.276.72 0 1.304-.576 1.304-1.276 0-.7-.584-1.276-1.304-1.276-.72 0-1.304.576-1.304 1.276zm1.928 0a.62.62 0 0 1-.624.636.62.62 0 0 1-.624-.636c0-.36.276-.636.624-.636s.624.276.624.636zm1.708-1.208v.276c.136-.22.356-.324.664-.312v.728c-.408 0-.644.224-.644.624v1.104h-.68v-2.42h.66zm1.736.592v.592c0 .424.276.612.656.6v.64h-.1c-.832 0-1.236-.552-1.236-1.2v-2h.68v.38c0 .328.268.576.636.584v.644c-.272 0-.484-.08-.636-.24zm1.924 1.412a.456.456 0 1 1-.912 0 .456.456 0 0 1 .912 0z",
      fill: "#fff",
    })
  );
};
Sofort24.defaultProps = {
  width: "34",
  height: "24",
  viewBox: "0 0 34 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Sofort24,
};
export function Sofort(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Sofort' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
